import React, { useEffect, useState } from 'react';

// styling
import { Colors, Spacing } from "_styles";

const TimelineCard = (props) => {

    return (
        <div
            style={{
                border: '1px solid lightgrey',
                borderTopWidth: '5px',
                borderTopColor: Colors.PRM_LIGHT_BLUE,
                maxHeight: props.height,
                height: props.height,
                width: '100%',
                minHeight: 0,
                display: 'flex',
                flexDirection: 'column',
                overflow: 'hidden',
                boxSizing: 'border-box',
            }}>
            {props.children}
        </div>
    );
};

export default TimelineCard;
